import "bootstrap-select";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "css-doodle";
import "./pdfViewer";
import "./tooltip";
import "./grid";
import "./box";
import "./autoFitColumns";
import "./debounceThrottle";
import "./performanceMonitor";
import "./registerBeforeUnload";
import "./welcome-banner";

window.$ = window.jQuery = $;